import AmazonLogo from '../../assets/svg-icons/stores/AmazonLogo.inline.svg';
import AppleMusicLogo from '../../assets/svg-icons/stores/AppleMusicLogo.inline.svg';
import BandcampLogo from '../../assets/svg-icons/stores/BandcampLogo.inline.svg';
import BeatportLogo from '../../assets/svg-icons/stores/BeatportLogo.inline.svg';
import CDBabyLogo from '../../assets/svg-icons/stores/CDBabyLogo.inline.svg';
import DeezerLogo from '../../assets/svg-icons/stores/DeezerLogo.inline.svg';
import GooglePlayLogo from '../../assets/svg-icons/stores/GooglePlayLogo.inline.svg';
import GrooveLogo from '../../assets/svg-icons/stores/GrooveLogo.inline.svg';
import ItunesLogo from '../../assets/svg-icons/stores/ItunesLogo.inline.svg';
import SoundcloudLogo from '../../assets/svg-icons/stores/SoundcloudLogo.inline.svg';
import SpotifyLogo from '../../assets/svg-icons/stores/SpotifyLogo.inline.svg';
import TidalLogo from '../../assets/svg-icons/stores/TidalLogo.inline.svg';
import YoutubeLogo from '../../assets/svg-icons/stores/YoutubeLogo.inline.svg';
import {EXTERNAL_LINK_SERVICES} from './ExternalLinks.constants';

export const ExternalLinkLogos = {
  [EXTERNAL_LINK_SERVICES.AMAZON]: AmazonLogo,
  [EXTERNAL_LINK_SERVICES.APPLE_MUSIC]: AppleMusicLogo,
  [EXTERNAL_LINK_SERVICES.BANDCAMP]: BandcampLogo,
  [EXTERNAL_LINK_SERVICES.BEATPORT]: BeatportLogo,
  [EXTERNAL_LINK_SERVICES.CD_BABY]: CDBabyLogo,
  [EXTERNAL_LINK_SERVICES.DEEZER]: DeezerLogo,
  [EXTERNAL_LINK_SERVICES.GOOGLE_PLAY]: GooglePlayLogo,
  [EXTERNAL_LINK_SERVICES.GROOVE]: GrooveLogo,
  [EXTERNAL_LINK_SERVICES.ITUNES]: ItunesLogo,
  [EXTERNAL_LINK_SERVICES.SOUNDCLOUD]: SoundcloudLogo,
  [EXTERNAL_LINK_SERVICES.SPOTIFY]: SpotifyLogo,
  [EXTERNAL_LINK_SERVICES.TIDAL]: TidalLogo,
  [EXTERNAL_LINK_SERVICES.YOUTUBE]: YoutubeLogo,
};
